module.exports = __webpack_public_path__ + "76422f0ed77e8e346ea49727c6b65779.png";